import { useState, useEffect } from 'react';
import { useToast } from '@/hooks/use-toast';

/**
 * Hook para detectar status de conectividade
 */
export const useOffline = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const { toast } = useToast();

  useEffect(() => {
    const handleOnline = () => {
      setIsOffline(false);
      toast({
        title: "Você está online novamente ✅",
        description: "Conectado à internet",
      });
    };

    const handleOffline = () => {
      setIsOffline(true);
      toast({
        title: "Você está offline 📡",
        description: "Algumas funcionalidades podem não estar disponíveis",
        variant: "destructive",
      });
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [toast]);

  return { isOffline };
};
